import { Component } from '@angular/core';
import { DashboardHelper } from '../../../services/dashboard.service';
import { RIGHT_PANEL_COLLAPSE_TOOLTIP, RIGHT_PANEL_EXPAND_TOOLTIP } from '../../../modules/catch-core/data/constants/blueprint.constants';

/**
 * The expand / collapse tab on the left edge of the right panel, vertically centred and stuck to the
 * edge like the Timeline table toggle, but as a rectangle rather than a circle.
 *
 * Whether it shows is `DashboardHelper.panelEdgeToggleVisible`: only the panels that can be widened
 * (the item edit panel and the Blueprint editor panels) switch it on, so the profile, video and
 * project panels do not get a toggle that does nothing for them.
 */
@Component({
  selector: 'app-panel-edge-toggle',
  templateUrl: './panel-edge-toggle.component.html',
  styleUrl: './panel-edge-toggle.component.css',
  standalone: false,
})
export class PanelEdgeToggleComponent {
  public readonly expandTooltip = RIGHT_PANEL_EXPAND_TOOLTIP;
  public readonly collapseTooltip = RIGHT_PANEL_COLLAPSE_TOOLTIP;

  constructor(public dashboardHelper: DashboardHelper) {}

  public onToggle(): void {
    this.dashboardHelper.setExpandRightPanel(!this.dashboardHelper.getExpandRightPanel());
  }
}
